import React from 'react'

//
import CareersHeadingSectionItem from '../CareersHeadingSectionItem'
import CareersHeadingShareSection from '../CareersHeadingShareSection'

const SectionItemsRow = ({ items = [] }) => {
  if (!items.length) {
    return null
  }

  return (
    <div className="c-careers__items-row">
      {items.map((item, idx) => (
        <CareersHeadingSectionItem key={`careers-item-${idx}`} {...item} />
      ))}
    </div>
  )
}

const CareersHeader = ({
  title,
  category,
  items = [],
  socials = [],
  shareLabel = '',
  applyCta = null
}) => (
  <section className="l-section c-careers__header">
    <div className="l-container:8/12 l-container--default-spacing">
      <h1>{title}</h1>
      <h3>{category}</h3>
    </div>
    <div className="l-container:8/12 l-container--default-spacing c-careers__header__items">
      <SectionItemsRow items={items.slice(0, 2)} />
      <SectionItemsRow items={items.slice(2, 4)} />
    </div>
    <div className="l-container:8/12 l-container--default-spacing c-careers__header__items">
      <CareersHeadingShareSection socials={socials} shareLabel={shareLabel} applyCta={applyCta} />
    </div>
  </section>
)

export default CareersHeader
